import { Box, Container, Grid, SxProps, Theme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import DetailInfoPanel from '../../../../shared/components/DetailInfoPanel'
import ButtonBack from '../../../../shared/components/buttons/ButtonBack'
import VerifyAccessRoute from '../../../../shared/components/routes/VerifyAccessRoute'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import NoveltyDetailContent from '../components/detail/NoveltyDetailContent'
import NoveltiesDetailNotifications from '../components/detail/NoveltyDetailNotification'
import NoveltyDetailSidebar from '../components/detail/NoveltyDetailSidebar'
import NoveltyModal from '../components/modal/NoveltyModal'
import { useNoveltyDetail } from '../hooks/useNoveltyDetail'

const customContainerStyles: SxProps<Theme> = {
  fontFamily: 'Poppins',
  '& img': {
    maxWidth: '100%'
  }
}

function NoveltyDetail() {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(960)

  const {
    isAdmin,
    noveltySelected,
    showForm,
    sortNovelties,
    content,
    favoriteState,
    authUser,
    infoDetail,
    handleShowNovelty,
    cutContent,
    handleFavoriteClick,
    handleToggleForm
  } = useNoveltyDetail(t)

  return (
    <>
      {noveltySelected != null && (
        <Container maxWidth="lg">
          {showForm && <NoveltyModal />}

          <ButtonBack />

          <Grid container spacing={isMobile ? 1 : 5} direction={isMobile ? 'column-reverse' : 'row-reverse'}>
            <Grid item xs={12} md={isAdmin ? 4 : 3}>
              <NoveltyDetailSidebar
                isAdmin={isAdmin}
                isMobile={isMobile}
                noveltySelected={noveltySelected}
                infoDetail={infoDetail}
                sortNovelties={sortNovelties}
                authUser={authUser}
                handleToggleForm={handleToggleForm}
                handleShowNovelty={handleShowNovelty}
                handleFavoriteClick={handleFavoriteClick}
                cutContent={cutContent}
              />
            </Grid>

            <Grid item xs={12} md={isAdmin ? 8 : 9}>
              <NoveltyDetailContent
                isAdmin={isAdmin}
                noveltySelected={noveltySelected}
                isMobile={isMobile}
                favoriteState={favoriteState}
                handleFavoriteClick={handleFavoriteClick}
              />

              <VerifyAccessRoute visibility={noveltySelected.visibility} />

              <img
                src={`${import.meta.env.VITE_AWS_URL}/novelties/${noveltySelected.image_url}`}
                alt={noveltySelected.title}
                width="100%"
              />

              <Box>
                <Box sx={customContainerStyles} dangerouslySetInnerHTML={{ __html: content }} />
              </Box>

              {isMobile ? <DetailInfoPanel attributes={infoDetail} /> : <></>}
            </Grid>
          </Grid>
        </Container>
      )}

      <NoveltiesDetailNotifications />
    </>
  )
}

export default NoveltyDetail
